import React from "react";
import * as S from "./AlertText.style";

interface AlertTextProps {
  button?: React.ReactNode;
  subText?: React.ReactNode;
  mainText?: string;
}

export const AlertText = ({ mainText, subText, button }: AlertTextProps) => {
  const buttonArray =
    React.isValidElement(button) && button.type === React.Fragment
      ? React.Children.toArray(button.props.children)
      : React.Children.toArray(button);
  const buttonCount = buttonArray.length;

  return (
    <S.AlertText>
      <S.TextBox>
        {mainText && <S.MainText>{mainText}</S.MainText>}
        {subText && <S.SubText>{subText}</S.SubText>}
      </S.TextBox>
      {buttonCount > 1 ? <S.multipleBtnBox>{button}</S.multipleBtnBox> : button}
    </S.AlertText>
  );
};
